import VueRouter from "vue-router";
import Vue from "vue";
const home = () => import("./components/home");
const terminal = () => import("./components/terminal"); //NOTE: Lazy loading

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "",
      component: home
    },
    { name: "terminal", path: "/terminal", component: terminal },
    {
      path: "*",
      component: home
    }
  ]
});
